<template>
  <div>
    <sticky v-if="promoteur" class="page-header sticky-page-header page-header--new" :back-button="true">
      <span slot="left-title">
        <router-link :to="{name: 'PromoteurList'}"
                     class="has-text-weight-black is-underline is-dotted">Promoteurs</router-link>
      </span>
      <span slot="left-content">
        <span class="has-text-weight-medium has-text-black">{{ promoteur.name }}</span>
      </span>
      <div class="column is-paddingless is-border-left" slot="left-action">
        <router-link :to="{name: 'StockPrograms', query: {promoteur: promoteur.pk}}"
                    class="page-header-btn is-small">
          <span class="icon is-small"><i class="fal fa-home"></i></span>
          <span>Programmes <span v-if="totalProgram !== null">({{ totalProgram }})</span></span>
        </router-link>
      </div>
      <router-link :to="{name: 'PromoteurEdit', id: promoteur.pk}" slot="dropdown-content" class="dropdown-item">
        <span class="icon is-small"><i class="fal fa-edit"></i></span>
        <span>Editer</span>
      </router-link>
      <a @click.prevent.stop="deletePromoteur" class="dropdown-item has-text-danger" slot="dropdown-content">
        <span class="icon is-small"><i class="fas fa-trash"></i></span><span>Supprimer</span>
      </a>
    </sticky>
    <div v-if="promoteur" class="columns is-gapless is-padding-top is-padding-left-on-btn-actions is-padding-right-on-btn-actions">
      <div class="column is-4 is-3-fullhd is-padding-right">
        <div class="card is-white is-bordered">
          <div class="columns is-vcentered">
            <div class="column"></div>
          </div>
          <div class="is-padding-left is-padding-right is-padding-bottom has-text-centered">
            <figure class="image is-128x128 is-margin-auto has-picto">
              <div class="is-border is-border-circle is-clipped">
                <img v-if="promoteur.picture" :src="promoteur.picture|avatarBig">
                <div v-else class="has-bg-light-darken-2 has-text-white is-clipped is-relative"
                  style="width:126px; height:126px; line-height:126px">
                    <i class="is-absolutecenter fas fa-kaaba fa-6x"></i>
                </div>
              </div>
            </figure>
            <div class="title is-3 is-margin-top-xsmall is-marginless-bottom"><b>{{promoteur.name}}</b></div>
          </div>
          <div class="columns is-multiline is-border-top">
            <div class="column is-12 is-border-dashed columns is-column is-space-between">
              <div class="has-text-grey is-size-6">Nombre de programmes</div>
              <em class="has-text-grey is-size-6" v-if="flux && flux.length">
                Dernière mise à jour du flux :
                <span class="is-underline">
                  le {{sortedFlux[0].created_on | prettyDate}} à {{sortedFlux[0].created_on | prettyTime}}
                </span>
              </em>
              <div class="is-margin-top-xsmall is-size-4" v-if="totalProgram">{{totalProgram}}</div>
              <span v-else>--</span>
            </div>
            <div class="column is-6 is-border-top is-border-right is-border-dashed columns is-column is-space-between">
              <div class="has-text-grey is-size-6">Flux Actif</div>
              <div class="is-margin-top-xsmall is-size-4">
                <span>{{promoteur.flux_enabled ? 'Oui' : 'Non'}}</span>
              </div>
            </div>
            <div class="column is-6 is-border-top is-border-dashed columns is-column is-space-between">
            </div>
          </div>
        </div>
      </div>
      <div class="column is-8 is-9-fullhd">
        <div class="has-bg-white is-border is-padding-bottom-xsmall">
          <div class="tabs is-separatedUnderlined is-marginless-bottom">
            <ul class="has-text-weight-medium">
              <li :class="{'is-active': panel === 'PROGRAM'}">
                <a @click="changePanel(PANELS.PROGRAM)">Programmes</a>
              </li>
              <li :class="{'is-active': panel === 'ACCESS'}" v-if="isAdmin">
                <a @click="changePanel(PANELS.ACCESS)">Mandats</a>
              </li>
              <li :class="{'is-active': panel === 'FLUX'}" v-if="sortedFlux && sortedFlux.length">
                <a @click="changePanel(PANELS.FLUX)">Rapport de flux</a></li>
            </ul>
          </div>
          <component :is="panelComponent"
                     v-if="promoteur && programs && flux"
                     :promoteur="promoteur"
                     :programs="programs"
                     :companies="companies"
                     :total="totalProgram"
                     :access="accesses"
                     :has-more="programPagination.pages > 1 && programPagination.nextPage !== null"
                     :flux="sortedFlux"
                     :loading="loading || loadingPrograms"
                     @reloadAccess="getAccesses(true)"
                     @loadMore="getPrograms"
          ></component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { DefaultValues } from '../../mixins'
  import { mapGetters, mapState } from 'vuex'
  import moment from 'moment'

  import ProgramPanel from './PromoteurProgramPanel'
  import PromoteurAccessPanel from './PromoteurAccessPanel'
  import FluxPanel from './PromoteurFluxPanel'

  const PANELS = Object.freeze({
    PROGRAM: 'PROGRAM',
    FLUX: 'FLUX',
    ACCESS: 'ACCESS'
  })

  export default {
    name: 'PromoteurVue',
    data () {
      return {
        promoteur: null,
        loading: false,
        loadingPrograms: false,
        totalProgram: null,
        programs: [],
        companies: [],
        accesses: [],
        users: [],
        flux: [],
        PANELS,
        panel: PANELS.PROGRAM,
        programPagination: {
          page: 1,
          pages: null,
          nextPage: null
        }
      }
    },
    computed: {
      ...mapState({
        companiesList: 'companies'
      }),
      ...mapGetters(['currentUserPk', 'isSeller', 'isManager', 'isAdmin', 'isExternal']),
      sortedFlux () {
        return this.flux.sort((a, b) => {
          return moment(b.created) - moment(a.created)
        })
      },
      panelComponent () {
        const components = {
          [PANELS.PROGRAM]: 'ProgramPanel',
          [PANELS.FLUX]: 'FluxPanel',
          [PANELS.ACCESS]: 'PromoteurAccessPanel'
        }
        return components[this.panel]
      },
      promoteurPk () {
        return this.$route.params.id
      }
    },
    watch: {
      promoteurPk (to, from) {
        if (to !== from) {
          this.getPromoteur()
          this.getPrograms()
          this.getFlux()
          this.getAccesses(true)
          this.companies = this.companiesList.slice()
        }
      }
    },
    mixins: [DefaultValues],
    components: {ProgramPanel, FluxPanel, PromoteurAccessPanel},
    methods: {
      changePanel (panel) {
        this.panel = panel
      },
      async getPromoteur () {
        this.loading = true
        let res = await this.$api.promoteurService.getOne(this.promoteurPk)
        this.loading = false
        this.promoteur = res.data
      },
      getPrograms (infiniteLoaderState = null) {
        this.loadingPrograms = true
        let params = {
          promoteur: this.promoteurPk,
          page: this.programPagination.nextPage || 1
        }
        this.$api.programService.get(params).then(r => {
          this.totalProgram = r.data.total
          this.programs = this.programs.concat(r.data.items)
          this.programPagination.pages = r.data.pages
          this.programPagination.page = r.data.page
          if (r.data.page && r.data.pages > r.data.page) {
            this.programPagination.nextPage = r.data.page + 1
          } else {
            this.programPagination.nextPage = null
          }
          if (infiniteLoaderState) {
            infiniteLoaderState.loaded()
          }
          this.loadingPrograms = false
        }).catch(r => {
          this.loadingPrograms = false
        })
      },
      getFlux () {
        let params = {
          promoteur: this.promoteurPk,
          per_page: 7
        }
        this.$api.fluxService.get(params).then(r => {
          this.flux = r.data.items.filter(x => x.promoteur === this.promoteurPk)
        })
      },
      deletePromoteur () {
        const d = {
          title: 'Suppression',
          text: 'Êtes vous sûr de vouloir supprimer ce promoteur?',
          confirmButtonText: 'Supprimer'
        }
        this.$swal(d).then(r => {
          if (r.value) {
            this.loading = true
            this.$api.promoteurService.delete(this.promoteurPk).then(res => {
              this.getPromoteurs()
              this.loading = false
              this.$router.push({name: 'PromoteurList'})
            }).catch(() => {
              this.loading = false
              this.$notify({
                type: 'is-danger',
                text: 'Impossible de supprimer ce promoteur.'
              })
            })
          }
        })
      },
      getPromoteurs (page = 1) {
        this.$api.promoteurService.get().then(res => {
          this.$store.commit('setPromoteurs', { promoteurs: res.data.items })
          if (res.data.page < res.data.pages) {
            page++
            this.getPromoteurs(page)
          }
        })
      },
      async getAccesses (init = false, page = 1) {
        this.loading = true
        let params = {page, per_page: 200, promoteur: this.promoteurPk}
        let res = await this.$api.accessService.getPromoteurAccess(params)
        if (init) {
          this.accesses = []
        }
        this.accesses = this.accesses.concat(res.data.items)
        if (res.data.pages > res.data.page) {
          await this.getAccesses(false, res.data.page + 1)
        } else {
          this.loading = false
        }
      }
    },
    created () {
      this.getPromoteur()
      this.getPrograms()
      this.getFlux()
      this.getAccesses(true)
      this.companies = this.companiesList.slice()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/promoteur/PromoteurVue.vue